import Colors from '@dynatrace/strato-design-tokens/colors';

import type { LegendColorMap } from '../types/internal.js';

export function getLegendItems(legendColorMap: LegendColorMap) {
  const legendEntries = [...legendColorMap.entries()];

  return legendEntries.map(([name, mapValue]) => ({
    id: name ?? '',
    color: mapValue.color ?? Colors.Charts.Categorical.Color01,
    name: name ?? '',
    value: mapValue.value,
  }));
}
